<script lang="ts">
	import { countries } from '../country/countries'
	import { CountryFlags } from './countryFlags'
	import { globalLocation } from '@repo/ui'
	import { Icon } from '@repo/ui'
	import { Tooltip } from '@repo/ui'
	import { GlobeEuropeAfrica } from '@steeze-ui/heroicons'

	interface Props {
		code: string
		noTooltip?: boolean
	}

	let { code, noTooltip = false }: Props = $props()
</script>

{#snippet flag()}
	<div class="*:h-5 *:w-5">
		{@html CountryFlags[code]}
	</div>
{/snippet}

<div class="inline-flex align-middle">
	<div class="flex h-5 w-5 items-center" aria-label={code} title={countries[code]}>
		{#if Object.keys(CountryFlags).includes(code)}
			{#if !noTooltip}
				<Tooltip block autoWidth placeholder={flag}>
					<div class="whitespace-nowrap">
						{countries[code]}
					</div>
				</Tooltip>
			{:else}
				{@render flag()}
			{/if}
		{:else if !code || code === globalLocation}
			<Icon src={GlobeEuropeAfrica} />
		{:else}
			{code}
		{/if}
	</div>
</div>
